// Libraries
var React = require('react');

class GoalkeeperLineupStats extends React.Component {
	render() {
		return (
			<div>
				<div className="LineupPlayer__stats">
					{!isNaN(this.props.MinutesPlayed) && this.props.MinutesPlayed > 0 &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Minutes Played</p>
								<p className="LineupPlayer__stat--value">{this.props.MinutesPlayed}</p>
							</div>
					}

					{!isNaN(this.props.GoalsConceded) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Goals Conceded</p>
								<p className="LineupPlayer__stat--value">{this.props.GoalsConceded}</p>
							</div>
					}

					{!isNaN(this.props.Saves) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Saves</p>
								<p className="LineupPlayer__stat--value">{this.props.Saves}</p>
							</div>
					}

					{!isNaN(this.props.Throws) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Throws</p>
								<p className="LineupPlayer__stat--value">{this.props.TotalThrows}</p>
							</div>
					}

					{!isNaN(this.props.Punches) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Punches</p>
								<p className="LineupPlayer__stat--value">{this.props.Punches}</p>
							</div>
					}

					{!isNaN(this.props.GoalsScored) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Goal Kicks</p>
								<p className="LineupPlayer__stat--value">{this.props.GoalKicks}</p>
							</div>
					}

					{!isNaN(this.props.YellowCards) && !isNaN(this.props.RedCards) &&
							<div className="LineupPlayer__stat">
								<p className="LineupPlayer__stat--heading">Cards</p>
								<p className="LineupPlayer__stat--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.YellowCards}</span> <span className="redcard" aria-label="Number of red cards">{this.props.RedCards}</span></p>
							</div>
					}
				</div>
			</div>
		)
	}
}

module.exports = GoalkeeperLineupStats;



// WEBPACK FOOTER //
// ./src/components/MDC/Lineup/GoalkeeperLineupStats.js